// Static institutional content extracted from ABLEMP presentation
export const LOGOS = {
  colorOnBlack:
    "https://customer-assets.emergentagent.com/job_defesa-meios-pag/artifacts/0s7knzn3_Logo_ABLEMP_Preto.png",
  white:
    "https://customer-assets.emergentagent.com/job_defesa-meios-pag/artifacts/jv44v0bn_Logo_ABLEMP_Branco.png",
  monoBlack:
    "https://customer-assets.emergentagent.com/job_defesa-meios-pag/artifacts/kab3klge_Logo_ABLEMP_mono_preto.png",
  swoosh:
    "https://customer-assets.emergentagent.com/job_defesa-meios-pag/artifacts/nyxdji0i_Ativo%205.png",
};

export const IMAGES = {
  heroPayments:
    "https://static.prod-images.emergentagent.com/jobs/329740f6-1003-4074-b7fb-7d2960e12cc3/images/02aad35494d2d984a5c4b6d773c691ff25ca09ac7cd5c11c92964ab18684f3e9.png",
  societyBW:
    "https://static.prod-images.emergentagent.com/jobs/329740f6-1003-4074-b7fb-7d2960e12cc3/images/9553ba68022c84b541a666cad20a83c9cf6499fe19ab84bab096cc720631a33c.png",
  commerce:
    "https://images.unsplash.com/photo-1707483618680-8c13c7fc3f69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxwYXltZW50JTIwdGVybWluYWwlMjBoYW5kfGVufDB8fHx8MTc3OTMxMzcxOXww&ixlib=rb-4.1.0&q=85",
  pos: "https://images.pexels.com/photos/9304565/pexels-photo-9304565.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  realNotes:
    "https://images.pexels.com/photos/27797867/pexels-photo-27797867.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  realNotes2:
    "https://images.pexels.com/photos/259103/pexels-photo-259103.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  realNotesBlue:
    "https://images.pexels.com/photos/7542641/pexels-photo-7542641.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  realNotesStack:
    "https://images.pexels.com/photos/7542861/pexels-photo-7542861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  realCoins:
    "https://images.pexels.com/photos/12323071/pexels-photo-12323071.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  cardPayment:
    "https://images.pexels.com/photos/6925809/pexels-photo-6925809.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  pixQr:
    "https://images.pexels.com/photos/12935064/pexels-photo-12935064.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
};

export const NAV = [
  { id: "manifesto", label: "Manifesto" },
  { id: "sobre", label: "Sobre" },
  { id: "causas", label: "Causas" },
  { id: "governanca", label: "Governança", route: "/governanca" },
  { id: "noticias", label: "Notícias e Artigos", route: "/noticias-e-artigos", external: true },
  { id: "contato", label: "Contato" },
];

// Governance
export const COUNCIL = [
  {
    name: "Sérgio Augusto França Patrocínio",
    role: "Presidente do Conselho Deliberativo",
  },
  { name: "Valter Magela Pontes", role: "Conselheiro" },
  { name: "Luiz Eduardo Seixa Stefani", role: "Conselheiro" },
  { name: "Alcides Roberto Martins", role: "Conselheiro" },
  { name: "Claudio Augusto Pereira Nunes", role: "Conselheiro" },
  { name: "Marco Aurelio Freitas", role: "Conselheiro" },
  { name: "Rodrigo Fernando Marchini", role: "Conselheiro" },
  { name: "Hélio Inoue", role: "Conselheiro" },
];

export const BOARD = [
  { name: "Rafael Drumond", role: "Presidente Executivo" },
  { name: "Marcello Nardi Neiva Machado", role: "Diretor Executivo" },
  {
    name: "Luciana Maria Rabello Rabello Maia Novaes",
    role: "Diretora Administrativa",
  },
  { name: "Flávio José de Almeida Pontes", role: "Diretor Financeiro" },
  { name: "Rafael Moisés Silva dos Anjos", role: "Diretor Adjunto" },
  { name: "Alan Martins Elbling", role: "Diretor Adjunto" },
];
export const BOARD_TERM = "Mandato 2026 / 2028";

export const VALUES = [
  {
    n: "01",
    title: "Liberdade de escolha",
    body:
      "Cada cidadão deve poder decidir, sem coerção, qual meio de pagamento utilizar — dinheiro, Pix, débito, crédito ou novas tecnologias.",
  },
  {
    n: "02",
    title: "Transparência",
    body:
      "Defendemos regras claras, taxas explícitas e responsabilidade pública por parte de quem opera infraestrutura de pagamentos no país.",
  },
  {
    n: "03",
    title: "Respeito ao consumidor",
    body:
      "Recusar um meio de pagamento legítimo é desrespeitar o Código de Defesa do Consumidor e fragilizar o pacto entre lojista e cidadão.",
  },
];

export const PILLARS = [
  {
    label: "Engajamento Social",
    body:
      "Mobilização da sociedade civil e dos pequenos negócios em defesa do direito de escolha.",
  },
  {
    label: "Livre Concorrência",
    body:
      "Mercado plural impede monopólios e garante inovação contínua nos meios de pagamento.",
  },
  {
    label: "Redução de Custos",
    body:
      "Mais opções ampliam a competição entre operadores e reduzem o custo final ao consumidor.",
  },
  {
    label: "Responsabilidade Social",
    body:
      "Inclusão financeira para milhões de brasileiros que ainda dependem do dinheiro físico.",
  },
];

export const CONSUMER_PILLARS = [
  "Liberdade de escolha",
  "Inclusão financeira",
  "Privacidade",
  "Segurança",
];

export const NEWS = [
  {
    tag: "Manifesto",
    date: "Dez 2025",
    title:
      "Por que recusar um meio de pagamento é uma decisão que afeta o país inteiro",
    excerpt:
      "Quando um estabelecimento impõe um único meio de pagamento, o impacto vai além do balcão: ele se reflete na inclusão financeira e na concorrência.",
  },
  {
    tag: "Análise",
    date: "Nov 2025",
    title:
      "Pix, dinheiro e cartão: a coexistência é o que protege o consumidor",
    excerpt:
      "Diversidade de meios é princípio de mercado saudável. A imposição de uma tecnologia única, mesmo eficiente, é forma silenciosa de exclusão.",
  },
  {
    tag: "Posicionamento",
    date: "Out 2025",
    title:
      "ABLEMP entrega manifesto sobre liberdade de escolha de meios de pagamento",
    excerpt:
      "Documento será enviado a órgãos reguladores, parlamentares e entidades de defesa do consumidor para abrir o debate público sobre o tema.",
  },
];

export const JOIN_STEPS = [
  {
    n: "01",
    title: "Conheça o manifesto",
    body: "Leia nossas bandeiras e entenda por que a liberdade de escolha importa.",
  },
  {
    n: "02",
    title: "Manifeste interesse",
    body: "Envie um e-mail apresentando você ou sua empresa e o motivo do apoio.",
  },
  {
    n: "03",
    title: "Receba o estatuto",
    body: "Vamos compartilhar o estatuto, direitos e deveres do associado.",
  },
  {
    n: "04",
    title: "Faça parte",
    body: "Após análise, você integra a rede de associados e ajuda a construir a pauta.",
  },
];

export const TICKER = [
  "Liberdade de escolha",
  "Inclusão financeira",
  "Defesa do consumidor",
  "Livre concorrência",
  "Transparência",
  "Responsabilidade social",
  "Privacidade",
  "Segurança",
];
